module.exports = __webpack_public_path__ + "img/P@2x.edd0ab54.jpg";